import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'app-info-field',
	templateUrl: './info-field.component.html',
	styleUrls: ['./info-field.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InfoFieldComponent implements OnInit {

	@Input() info: String;

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/info-field/info-field.component.ts